<template>
  <MiniCalendarLoading />
  <router-view></router-view>
</template>

<script>
import MiniCalendarLoading from "./components/mini-calendar-loading.vue";

export default {
  name: "App",
  components: {
    MiniCalendarLoading,
  },
};
</script>
